import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VaultConnectionComponent } from '@app/shared/components/vault-connection/vault-connection.component';

@NgModule({
    imports: [CommonModule],
    declarations: [VaultConnectionComponent],
    entryComponents: [VaultConnectionComponent],
    exports: [VaultConnectionComponent]
})
export class VaultConnectionModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/vault-connection/vault-connection.module.ts